import isEqual from 'lodash/isEqual'

// 检测前后值是否变更
const checkValueIsChanged = (oldVal, newVal) => {
    return !isEqual(oldVal, newVal)
}

// 检测是否清除快捷查询选中
export default ({ quickSearchPreOptions, quickSearchOptions, quickSearchSelected, changedValues }) => {
    const quickOption = (quickSearchPreOptions || [])
        .concat(quickSearchOptions || [])
        .find(v => v.key === quickSearchSelected)

    if (quickOption?.fields) {
        // 先简单处理，后续再改
        const inFieldKeys = Object.keys(quickOption.fields).filter(fieldKey => changedValues.hasOwnProperty(fieldKey))

        if (inFieldKeys?.length) {
            return inFieldKeys.some(fieldKey =>
                checkValueIsChanged(quickOption.fields?.[fieldKey]?.value, changedValues[fieldKey])
            )
        }
    }

    return false
}
